import { UnifiedColorPicker } from '../../../unifiedColorPicker/unifiedColorPicker'
import camelCase from 'lodash/camelCase'
import React, { useEffect, useRef, useState } from 'react'
import { TCanvas } from '../../Canvas'
import { IOnlineEditorColorOptionConfig } from '../../onlineEditorProductColors.config'

export function ColorPicker({
  colorPickerConfig,
  canvasConfig,
  onClose,
  onSelected,
}: {
  colorPickerConfig: IOnlineEditorColorOptionConfig
  canvasConfig: TCanvas
  onClose: () => void
  onSelected: (color, label) => void
}) {
  const pickerWrapperRef = useRef(null)
  const [pickerWrapperHeight, setPickerWrapperHeight] = useState(0)

  useEffect(() => {
    if (!pickerWrapperRef.current) return

    const resizeObserver = new ResizeObserver(() => {
      setPickerWrapperHeight(
        pickerWrapperRef?.current?.clientHeight ||
          pickerWrapperRef?.current?.offsetHeight
      )
    })

    resizeObserver.observe(pickerWrapperRef.current)
    return () => resizeObserver.disconnect()
  }, [])

  return (
    <div
      ref={pickerWrapperRef}
      key={colorPickerConfig.key}
      /* It must have [online-editor-color-picker] class to apply correct
       * overrides to color picker styles imported from ChromePicker package.
       */
      className={`w-full absolute top-0 left-0 right-0 bottom-0 bg-white online-editor-color-picker`}
      onClick={(e) => e.stopPropagation()}
    >
      <UnifiedColorPicker
        tabs={colorPickerConfig.pickerConfig}
        initialColors={[canvasConfig[camelCase(colorPickerConfig.key)]] || null}
        onSelected={(color) => {
          if (color.value) {
            onSelected(color.value, color.label)
          }
        }}
        onClose={onClose}
        wrapperHeight={pickerWrapperHeight || 320}
      />
    </div>
  )
}
